import React from 'react';
import { motion } from 'framer-motion';
export function UpsellSection() {
  const comparisonRows = [{
    situation: 'Querés más privacidad',
    without: 'Solo protección básica',
    with: 'Anonimato total en la red'
  }, {
    situation: 'Tus datos están en Google',
    without: 'Siguen expuestos',
    with: 'Borrado completo de huella digital'
  }, {
    situation: 'Navegás por internet',
    without: 'Dejás rastros en cada click',
    with: 'Navegación fantasma activada'
  }, {
    situation: 'Tus ahorros en crypto',
    without: 'Solo tenés teoría',
    with: 'Protección de activos reales'
  }, {
    situation: 'Tus dispositivos te preocupan',
    without: 'Configuración estándar',
    with: 'Grado de seguridad militar'
  }];
  const kitIncludes = ['Borrado de Huella Digital', 'Navegación Fantasma', 'Crypto-Seguridad para Ahorristas', 'Dispositivos de Grado Militar'];
  return <section className="w-full py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #050816 0%, #0d1333 40%, #101840 60%, #0d1333 80%, #050816 100%)'
  }} data-id="element-332">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-[0.07] pointer-events-none" style={{
      background: 'radial-gradient(circle, #00D4FF 0%, transparent 70%)'
    }} data-id="element-333" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[200px] opacity-[0.08] pointer-events-none" style={{
      background: 'radial-gradient(ellipse, #00D4FF 0%, transparent 70%)'
    }} data-id="element-334" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center relative z-10" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-336">
          <div className="inline-flex items-center gap-2 text-brand-cyan text-xs font-bold tracking-[0.3em] uppercase mb-5 px-5 py-2 rounded-full border border-brand-cyan/30" style={{
          background: 'linear-gradient(135deg, rgba(0,212,255,0.08) 0%, rgba(0,212,255,0.02) 100%)',
          boxShadow: '0 0 20px rgba(0,212,255,0.1), 0 0 40px rgba(0,212,255,0.05)'
        }} data-id="element-337">
            <span style={{
            textShadow: '0 0 10px rgba(0,212,255,0.5)'
          }} data-id="element-338">
              ⚡
            </span>
            UPGRADE EXCLUSIVO
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-339">
            ¿Qué agrega la{' '}
            <span className="text-brand-cyan" style={{
            textShadow: '0 0 20px rgba(0,212,255,0.4)'
          }} data-id="element-340">
              Serie Black
            </span>
            ?
          </h2>
          <p className="text-gray-400 mt-3 text-sm sm:text-base max-w-xl mx-auto" data-id="element-341">
            Pasá de estar protegido a ser{' '}
            <span className="text-white font-semibold" data-id="element-342">invisible</span>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full rounded-2xl overflow-hidden mb-20" style={{
        border: '1px solid rgba(0, 212, 255, 0.25)',
        background: 'linear-gradient(180deg, #0d1333 0%, #0a0f2e 100%)',
        boxShadow: '0 0 50px rgba(0,212,255,0.08), 0 0 100px rgba(0,212,255,0.03), 0 20px 60px rgba(0,0,0,0.5)'
      }} data-id="element-343">
          <div className="grid grid-cols-3" style={{
          background: 'linear-gradient(90deg, #0d1333 0%, #101840 50%, #0d1333 100%)',
          borderBottom: '1px solid rgba(0, 212, 255, 0.2)'
        }} data-id="element-344">
            <div className="p-5 sm:p-6 font-bold text-white/80 text-xs sm:text-sm uppercase tracking-wider" data-id="element-345">
              Situación
            </div>
            <div className="p-5 sm:p-6 font-bold text-red-400 sm:text-sm uppercase tracking-wider flex gap-2 border-l border-white/5 text-[11px] flex-row items-center justify-center" style={{
            background: 'linear-gradient(180deg, rgba(239,68,68,0.06) 0%, transparent 100%)',
            textShadow: '0 0 8px rgba(239,68,68,0.3)'
          }} data-id="element-346">
              <span className="text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.6)]" data-id="element-347">
                ✕
              </span>{' '}
              Sin Serie Black
            </div>
            <div className="p-5 sm:p-6 font-bold text-brand-cyan sm:text-sm uppercase tracking-wider flex gap-2 border-l border-white/5 text-[11px] items-center justify-center" style={{
            background: 'linear-gradient(180deg, rgba(0,212,255,0.08) 0%, transparent 100%)',
            textShadow: '0 0 8px rgba(0,212,255,0.4)'
          }} data-id="element-348">
              <span className="text-brand-cyan drop-shadow-[0_0_6px_rgba(0,212,255,0.6)]" data-id="element-349">
                ✓
              </span>{' '}
              Con Serie Black
            </div>
          </div>

          {comparisonRows.map((row, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="grid grid-cols-3 group transition-all duration-300 hover:bg-brand-cyan/[0.03]" style={{
          borderBottom: index < comparisonRows.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
          background: index % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.015)'
        }} data-id="element-350">
              <div className="p-5 sm:p-6 text-gray-300 text-sm sm:text-base flex items-center leading-relaxed" data-id="element-351">
                {row.situation}
              </div>
              <div className="p-5 sm:p-6 text-gray-500 text-sm sm:text-base flex items-center border-l border-white/5 leading-relaxed" data-id="element-352">
                {row.without}
              </div>
              <div className="p-5 sm:p-6 text-white font-medium text-sm sm:text-base flex items-center border-l border-brand-cyan/10 leading-relaxed group-hover:text-brand-cyan transition-colors duration-300" data-id="element-353">
                {row.with}
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full flex flex-col items-center" data-id="element-354">
          <div className="flex items-center gap-3 mb-10" data-id="element-355">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-brand-cyan/50" data-id="element-356" />
            <h3 className="text-lg sm:text-xl font-bold text-white uppercase tracking-wider flex items-center gap-2" style={{
            textShadow: '0 0 15px rgba(255,255,255,0.1)'
          }} data-id="element-357">
              <span className="text-brand-cyan drop-shadow-[0_0_8px_rgba(0,212,255,0.5)]" data-id="element-358">
                ✅
              </span>{' '}
              La Serie Black incluye:
            </h3>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-brand-cyan/50" data-id="element-359" />
          </div>

          <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3 max-w-3xl" data-id="element-360">
            {kitIncludes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.3
          }} className="border border-brand-cyan/30 rounded-full px-5 py-2 text-sm text-white font-semibold cursor-default hover:border-brand-cyan/60 hover:scale-105 transition-all duration-300" style={{
            background: 'linear-gradient(135deg, rgba(0,212,255,0.08) 0%, rgba(0,212,255,0.02) 100%)',
            boxShadow: '0 0 20px rgba(0,212,255,0.08), 0 0 40px rgba(0,212,255,0.03)'
          }} data-id="element-361">
                {item}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}